import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { Web3Info } from "src/components/web3Info";
import { ProviderItems } from "src/models/StakingPool";

import linkIcon from "src/assets/images/icon_link.svg";
import connextIcon from "src/assets/images/icon_connext.svg";
import ApronIcon from "src/assets/images/icon_apron.svg";
import TornIcon from "src/assets/images/icon_torn.svg";
import AstarIcon from "src/assets/images/icon_astar.svg";
import CeramicIcon from "src/assets/images/icon_ceramic.png";
import IPFSIcon from "src/assets/images/icon_IPFS.svg";
import ShidenIcon from "src/assets/images/icon_shiden.svg";
import NYMIcon from "src/assets/images/icon_nym.svg";
import BitmapIcon from "src/assets/images/icon_bitmap.png";
import web3BG from "src/assets/images/web3BG.png";
import fortaIcon from "src/assets/images/icon_forta.png";
import theGraphIcon from "src/assets/images/icon_theGraph.svg";
import meterIcon from "src/assets/images/icon_meter.png"

const infrastructureProviderDatas: ProviderItems[] = [{
  nodeName: "Chainlink",
  subTitle: "Data Provider",
  buttonText: "Details",
  url: "https://market.link/nodes/d018f48c-2412-44f5-bf02-76394b454875/feeds",
  icon: linkIcon
}, {
  nodeName: "Connext",
  subTitle: "Liquidity Provider",
  buttonText: "Details",
  url: "https://connextscan.io/router/0xfbf8b0394c5936a18731ea7086b19856ddad1023",
  icon: connextIcon
}, {
  nodeName: "Astar",
  subTitle: "Collator",
  buttonText: "Details",
  url: "https://astar.subscan.io/account/aCjn9DDdCqGredzxPjpRxabveyPUBJgP5cB3GLC3WBxg3rf?tab=transfer",
  icon: AstarIcon
}, {
  nodeName: "IPFS",
  subTitle: "Gateway",
  buttonText: "Details",
  type: "Soon",
  url: "https://ipfs.wetez.io/",
  showModal: true,
  icon: IPFSIcon,
  modalTitle: "IPFS Public Gateway",
  describe: "IPFS gateway resolves access to any requested IPFS content identifier."
}, {
  nodeName: "Gravity Bridge",
  subTitle: "IBC Relayer",
  buttonText: "Details",
  url: "https://www.mintscan.io/gravity-bridge/relayers/channel-64",
  showModal: false,
  icon: BitmapIcon
}, {
  nodeName: "Shiden",
  subTitle: "Collator",
  buttonText: "Details",
  url: "https://shiden.subscan.io/account/ZLuQAH9JmXsafg8QrUhqRCQX6tzBKD1W13M5UYGAybBw533?tab=transfer",
  showModal: false,
  icon: ShidenIcon
}, {
  nodeName: "NYM",
  subTitle: "Privacy Node",
  buttonText: "Details",
  url: "https://mixnet.explorers.guru/mixnode/J7LQjuL8yiuXNjUSTgpy6eRijtz4V8CQihYgh8BMCscS",
  showModal: false,
  icon: NYMIcon
}, {
  nodeName: "Apron",
  subTitle: "API Provider",
  type: "Soon",
  buttonText: "//",
  url: "https://tornado-1.wetez.io",
  icon: ApronIcon
}, {
  nodeName: "Ceramic",
  subTitle: "Gateway",
  buttonText: "Soon",
  type: "Soon",
  icon: CeramicIcon
},{
  nodeName:"Forta",
  subTitle: "Scanner",
  buttonText: "Details",
  url: "https://explorer.forta.network/alerts?addresses[]=0x12184A71655441EcFae4fd588bFedda0e3105de2",
  showModal: false,
  icon: fortaIcon
},{
  nodeName:"Meter",
  subTitle: "Bridge",
  buttonText: "//",
  url: "",
  type: "Soon",
  showModal: false,
  icon: meterIcon
}, {
  nodeName: "The Graph",
  subTitle: "Indexer",
  buttonText: "Details", 
  icon: theGraphIcon,
  url: "https://thegraph.com/explorer/profile?id=0x376ca6892ab19bfd90515257b5f6b31561c300aa&view=Indexing",
}];
export const Web3 = () => {
  return (
    <>
      <Box style={{
        width: "100%",
        background: "linear-gradient(to right,#FFFFFF,#FFFFFF,#FFFFFF,#FFFFFF,#E4F0FF)",

      }} display="flex" flexDirection="column" alignItems="center">
        <Box p="50px 95px 92px" width="1280px" position="relative">
          <img src={web3BG} style={{
            top: "52px",
            right: "100px",
            position: 'absolute'
          }} />
          <Typography
            fontSize="30px"
            variant="bold"
            color="#0E1011"
            lineHeight="30px"
          >
            Web3 Infrastructure
          </Typography>

          <Typography fontSize="16px" lineHeight="16px" color="#848484" mt="20px">
          How to delegate/vote to Wetez in Web3 Portals
          </Typography>

          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="20px"
          >
            Step1: Find details of the project portal.
          </Typography>

          <Typography
            fontSize="16px"
            lineHeight="16px"
            color="#0E1011"
            mt="8px"
          >
            Step2: Delegate or Vote to Wetez, then sit behind and enjoy the reward.
          </Typography>

           
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" alignItems="center">
        <Box width="1280px" id="pools">
          <Web3Info datas={infrastructureProviderDatas}
            moreUrl="/stakingPools"
            title="Web3 Infrastructure"
            subTitle="Keep building services for Web3" />
        </Box>
      </Box>
    </>
  );
};